import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Injectable, Inject, forwardRef, Type } from '@angular/core';

@Injectable()
export class DialogService {

    private componentType: Type<any>;
    private confirmComponentType: Type<any>;


    constructor( @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog) {

    }

    setComponentType(componentType: Type<any>) {
        this.componentType = componentType;
    }

    setConfirmComponentType(componentType: Type<any>) {
        this.confirmComponentType = componentType;
    }

    openDialog(title: string, html: string) {
        let dialog = this.dialog.open(this.componentType, <MatDialogConfig>{
        });
        dialog.componentInstance.html = html;
        dialog.componentInstance.title = title;
    }

    openConfirmDialog(title: string, html: string, onConfirm: () => void, onCancel: () => void) {
        let dialog = this.dialog.open(this.confirmComponentType, <MatDialogConfig>{
        });
        dialog.componentInstance.html = html;
        dialog.componentInstance.title = title;
        dialog.componentInstance.confirm.subscribe((e) => {
            if (e) {
                onConfirm();
            } else {
                onCancel();
            }

        });
    }


}


// WEBPACK FOOTER //
// ./src/app/shared/services/dialog-service.ts